/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const TertiaryText = styled.div({
  marginTop: token('space.200', '16px'),
  color: token('color.text.subtlest', colors.N200),
  maxWidth: '357px',
});

export const TertiaryFooterText = styled.div({
  marginTop: token('space.100', '8px'),
  color: token('color.text.subtlest', colors.N200),
});

export const LearnMoreLink = styled.a({
  margin: '0 3px',
});

export const PageContainer = styled.div({
  maxWidth: '1440px',
  margin: '0 auto',
});

export const Promo = styled.div({
  display: 'flex',
});

export const PromoImage = styled.div({
  flexGrow: 1,
  marginBottom: token('space.250', '20px'),
  '& > video': {
    borderRadius: '10px',
    boxShadow: `${token(
      'elevation.shadow.raised',
      'rgba(0, 0, 0, 0.1)'
    )} 3px 3px 5px`,
  },
});

export const PromoMenu = styled.div({
  flexShrink: 0,
  marginLeft: token('space.250', '20px'),
  width: '300px',
});

export const PromoButton = styled.button<{
  selected?: boolean;
}>(props => ({
  backgroundColor: props.selected
    ? token('elevation.surface.raised', colors.N20)
    : 'transparent',

  border: 0,
  outline: 0,
  margin: `${token('space.050', '4px')} 0`,
  padding: `${token('space.150', '12px')} ${token('space.250', '20px')}`,
  font: token('font.body.large'),
  textAlign: 'left',
  cursor: 'pointer',

  '&:focus': {
    backgroundColor: token('elevation.surface.raised', colors.N20),
  },

  '&:hover': {
    backgroundColor: token('elevation.surface.raised', colors.N20),
  },
}));

export const PromoButtonTitle = styled.div({
  color: token('color.text', colors.N800),
  font: token('font.heading.small'),
  marginTop: '3px',
});

export const PromoButtonDescription = styled.div({
  color: token('color.text.subtlest', colors.N800),
  marginTop: '3px',
});

export const Footer = styled.div({
  display: 'flex',
  position: 'sticky',
  bottom: 0,
  height: token('space.1000', '80px'),
  borderTop: `${token('space.025', '2px')} solid ${token(
    'color.background.neutral',
    colors.N40
  )}`,
  paddingTop: token('space.400', '32px'),
  backgroundColor: token('elevation.surface.raised', colors.N20),
});

export const FooterLeft = styled.div({
  flexGrow: 1,
});
export const FooterRight = styled.div({
  textAlign: 'right',
  width: '300px',
});
